import { render, staticRenderFns } from "./MTourTip.vue?vue&type=template&id=f8c0aebc"
import script from "./MTourTip.vue?vue&type=script&lang=js"
export * from "./MTourTip.vue?vue&type=script&lang=js"
import style0 from "./MTourTip.vue?vue&type=style&index=0&id=f8c0aebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports